
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import Button from '../base/Button';

export default function Header() {
  const { t } = useTranslation();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  
  const navItems = [
    { name: t('Home'), href: '#home' },
    { name: t('About'), href: '#about' },
    { name: t('Courses'), href: '#courses' },
    { name: t('Pricing'), href: '#pricing' },
    { name: t('FAQ'), href: '#faq' }
  ];
  
  return (
    <header className="bg-white shadow-sm sticky top-0 z-50">
      <div className="container mx-auto px-6">
        <div className="flex items-center justify-between h-16">
          {/* Logo */}
          <div className="flex items-center">
            <div className="w-10 h-10 bg-blue-600 rounded-lg flex items-center justify-center mr-3">
              <i className="ri-riding-line text-white text-xl"></i>
            </div>
            <h1 className="text-xl font-bold text-gray-900" style={{ fontFamily: '"Pacifico", serif' }}>
              {t('Action English')}
            </h1>
          </div>
          
          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-8">
            {navItems.map((item) => (
              <a
                key={item.name}
                href={item.href}
                className="text-gray-700 hover:text-blue-600 transition-colors cursor-pointer"
              >
                {item.name}
              </a>
            ))}
            <a
              href="https://www.instagram.com/rampupenglish?igsh=NG9vZTBwY3F2bGw1&utm_source=qr"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center text-gray-700 hover:text-blue-600 transition-colors cursor-pointer"
            >
              <i className="ri-instagram-line text-xl mr-2"></i>
              Instagram
            </a>
            <a
              href="https://www.instagram.com/rampupenglish?igsh=NG9vZTBwY3F2bGw1&utm_source=qr"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center text-gray-700 hover:text-blue-600 transition-colors cursor-pointer"
            >
              <i className="ri-message-3-line text-xl mr-2"></i>
              お問い合わせ
            </a>
          </nav>
          
          {/* Mobile Menu Button */}
          <button
            className="md:hidden w-10 h-10 flex items-center justify-center cursor-pointer"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
          >
            <i className={`${isMenuOpen ? 'ri-close-line' : 'ri-menu-line'} text-2xl text-gray-700`}></i>
          </button>
        </div>
        
        {/* Mobile Navigation */}
        {isMenuOpen && (
          <div className="md:hidden py-4 border-t border-gray-200">
            <nav className="flex flex-col space-y-4">
              {navItems.map((item) => (
                <a
                  key={item.name}
                  href={item.href}
                  className="text-gray-700 hover:text-blue-600 transition-colors cursor-pointer"
                  onClick={() => setIsMenuOpen(false)}
                >
                  {item.name}
                </a>
              ))}
              <a
                href="https://www.instagram.com/rampupenglish?igsh=NG9vZTBwY3F2bGw1&utm_source=qr"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center text-gray-700 hover:text-blue-600 transition-colors cursor-pointer"
                onClick={() => setIsMenuOpen(false)}
              >
                <i className="ri-instagram-line text-xl mr-2"></i>
                Instagram
              </a>
              <a
                href="https://www.instagram.com/rampupenglish?igsh=NG9vZTBwY3F2bGw1&utm_source=qr"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center text-gray-700 hover:text-blue-600 transition-colors cursor-pointer"
                onClick={() => setIsMenuOpen(false)}
              >
                <i className="ri-message-3-line text-xl mr-2"></i>
                お問い合わせ
              </a>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
}
